// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__KWUg3","text":"style_text__bZGfO","btn":"style_btn__i9sci"};